// extracted by mini-css-extract-plugin
module.exports = {"panel":"sign-in-tab-panel_panel__Rkiit","divider":"sign-in-tab-panel_divider__LdRfS"};